const WIDGET_COOKIE_NAME = 'amlbot.w.init';

interface WidgetUser {
  username: string;
  externalId: string;
}

interface WidgetCacheEntry {
  appId: string;
  user: WidgetUser;
}

export { WIDGET_COOKIE_NAME };
export type { WidgetUser, WidgetCacheEntry };
